import React from 'react';

import { useLocation } from 'react-router-dom';
import Header from './Header';
import Knoppie from './Knoppie';
import {Link} from 'react-router-dom'
import Antwoord from './Antwoord';
import  Text from './Text';



const Einde = () => {

  console.log(JSON.parse(localStorage.getItem("vrae")))
  const vrae = JSON.parse(localStorage.getItem("vrae"))
  const location = useLocation()
  const colorone = location.state.colorone
  const colortwo = location.state.colortwo

  console.log(colorone)
  
  const handleprint = ()=>{
    window.print()
  }
  
  return (
    <>
    <div>
    {/* <ReactToPrint
    trigger={()=>{
     return <button>Print jou uitslae</button>
    }}
    content={()=>this.componentRef}
    documentTitle='UItslae'
    pageStyle= "print"
    /> */}
    <div >
      <Header colorone={colorone} colortwo={colortwo}/>
      <Text text="Einde van die Game, Hier is jou uitslae:"></Text>

      
      <div>{vrae.map(vraag=>(
        <div key={vraag.id}>

          <Antwoord vraag={vraag.vraag} antwoord={vraag.antwoord} korrek={vraag.korrek} reg={vraag.reg} colorone={colorone} colortwo={colortwo}></Antwoord>

        </div>
      ))}</div>
    </div>
      
                
        <div>
        
        <button onClick={handleprint}>Print</button>

        <Link to='/'>

          <Knoppie
           nommer = {"Speel weer?"} 
           colorone={colorone}
           colortwo={colortwo}
          />

        </Link>

        </div>
    
        </div>
    </>
  );
};

export default Einde;
